import React from "react";
import { Link, Redirect } from "react-router-dom";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Collapse,
  NavItem,
  NavLink
} from "shards-react";

class UserActions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      logout: false
    };

    this.toggleUserActions = this.toggleUserActions.bind(this);
  }

  handleClickLogOut = () => {
    localStorage.clear()
    this.setState({
      ...this.state,
      logout: true
    });
  }

  toggleUserActions() {
    this.setState({
      visible: !this.state.visible
    });
  }

  render() {
    if (this.state.logout) {
      localStorage.removeItem('token');
      return <Redirect to="/login" />
    }
    return (
      <NavItem tag={Dropdown} caret toggle={this.toggleUserActions}>
        <DropdownToggle caret tag={NavLink} className="text-nowrap px-3">
          <img
            className="user-avatar rounded-circle mr-2"
            src={ localStorage.getItem('photo') }
            alt="User Avatar"
          />{" "}
          <span className="d-none d-md-inline-block">{ localStorage.getItem('name') }</span>
        </DropdownToggle>
        <Collapse tag={DropdownMenu} right small open={this.state.visible}>
          <DropdownItem tag={Link} to={`/user/view/${localStorage.getItem('_id')}`}>
            <i className="material-icons">&#xE7FD;</i> My Profile
          </DropdownItem>
          <DropdownItem tag={Link} to="/dashboard">
            <i className="material-icons">&#xe871;</i> Dashboard
          </DropdownItem>
          <DropdownItem tag={Link} to="/dashboard-2">
            <i className="material-icons">&#xe871;</i> Dashboard 2
          </DropdownItem>
          <DropdownItem divider />
          <DropdownItem onClick={this.handleClickLogOut} className="text-danger">
            <i className="material-icons text-danger">&#xE879;</i> Logout
          </DropdownItem>
        </Collapse>
      </NavItem>
    );
  }
}

export default UserActions;